import { render, staticRenderFns } from "./MyProductDetails.vue?vue&type=template&id=01bf7e48&"
import script from "./MyProductDetails.vue?vue&type=script&lang=js&"
export * from "./MyProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports